/**
 * Generated from ch4_p02.fla
 */
export function ch4_p02(this: Ich4_p02) {
	const holly = this.holly;
	if (!holly[0] && holly.elementFactory) {
		holly[0] = holly.elementFactory(0,undefined);
	}
	if (holly[0]) {
		ch4_p02_hh_ch4_p0204psdAssetchp4_p02_hollyp2.call(holly[0] as Ich4_p02_hh_ch4_p0204psdAssetchp4_p02_hollyp2);
		holly[0].x = 721.25;
		holly[0].y = 449;
		holly[0].width = 407.50;
		holly[0].height = 541.00;
		holly[0].alpha = 1;
		if (holly[0].onLayout) holly[0].onLayout();
	}
	if (!holly[1] && holly.elementFactory) {
		holly[1] = holly.elementFactory(1,undefined);
	}
	if (holly[1]) {
		ch4_p02_hh_ch4_p0204psdAssetchp4_p02_hollyp3.call(holly[1] as Ich4_p02_hh_ch4_p0204psdAssetchp4_p02_hollyp3);
		holly[1].x = 762.75;
		holly[1].y = 436.5;
		holly[1].width = 490.50;
		holly[1].height = 566.00;
		holly[1].alpha = 1;
		if (holly[1].onLayout) holly[1].onLayout();
	}
	if (!holly[2] && holly.elementFactory) {
		holly[2] = holly.elementFactory(2,undefined);
	}
	if (holly[2]) {
		ch4_p02_hh_ch4_p0204psdAssetchp4_p02_hollyp4.call(holly[2] as Ich4_p02_hh_ch4_p0204psdAssetchp4_p02_hollyp4);
		holly[2].x = 734;
		holly[2].y = 440.75;
		holly[2].width = 433.00;
		holly[2].height = 557.50;
		holly[2].alpha = 1;
		if (holly[2].onLayout) holly[2].onLayout();
	}
	const bg = this.bg;
	ch4_p02_hh_ch4_p0204psdAssetchp4_p02_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const guitarStand = this.guitarStand;
	ch4_p02_hh_ch4_p0204psdAssetchp4_p02_guitarstand.call(this.guitarStand);
	guitarStand.x = 591.75;
	guitarStand.y = 493.5;
	guitarStand.width = 106.50;
	guitarStand.height = 301.00;
	guitarStand.alpha = 1.00;
	if (guitarStand.onLayout) guitarStand.onLayout();
	const basket = this.basket;
	ch4_p02_hh_ch4_p0204psdAssetchp4_p02_basket.call(this.basket);
	basket.x = 1030.5;
	basket.y = 656.75;
	basket.width = 259.00;
	basket.height = 222.50;
	basket.alpha = 1.00;
	if (basket.onLayout) basket.onLayout();
	const frameRight = this.frameRight;
	ch4_p02_hh_ch4_p0204psdAssetchp4_p02_wcframePixellayercopy.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 356.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const frameLeft = this.frameLeft;
	ch4_p02_hh_ch4_p0204psdAssetchp4_p02_wcframePixellayercopy2.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 344.00;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const linesLeft = this.linesLeft;
	ch4_p02_hh_ch4_p0204psdAssetchp4_p02_wcframeRlineart.call(this.linesLeft);
	linesLeft.x = 0;
	linesLeft.y = 358.25;
	linesLeft.width = 77.50;
	linesLeft.height = 626.50;
	linesLeft.alpha = 1.00;
	if (linesLeft.onLayout) linesLeft.onLayout();
	const linesRight = this.linesRight;
	ch4_p02_hh_ch4_p0204psdAssetchp4_p02_wcframeLlineart.call(this.linesRight);
	linesRight.x = 1664;
	linesRight.y = 699.25;
	linesRight.width = 205.00;
	linesRight.height = 60.50;
	linesRight.alpha = 1.00;
	if (linesRight.onLayout) linesRight.onLayout();
	return this;
}
function ch4_p02_hh_ch4_p0204psdAssetchp4_p02_bg(this: Ich4_p02_hh_ch4_p0204psdAssetchp4_p02_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p02_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p02_hh_ch4_p0204psdAssetchp4_p02_guitarstand(this: Ich4_p02_hh_ch4_p0204psdAssetchp4_p02_guitarstand) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p02_guitarstand", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p02_hh_ch4_p0204psdAssetchp4_p02_basket(this: Ich4_p02_hh_ch4_p0204psdAssetchp4_p02_basket) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p02_basket", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p02_hh_ch4_p0204psdAssetchp4_p02_hollyp2(this: Ich4_p02_hh_ch4_p0204psdAssetchp4_p02_hollyp2) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p02_hollyp2", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p02_hh_ch4_p0204psdAssetchp4_p02_hollyp3(this: Ich4_p02_hh_ch4_p0204psdAssetchp4_p02_hollyp3) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p02_hollyp3", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p02_hh_ch4_p0204psdAssetchp4_p02_hollyp4(this: Ich4_p02_hh_ch4_p0204psdAssetchp4_p02_hollyp4) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p02_hollyp4", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p02_hh_ch4_p0204psdAssetchp4_p02_wcframePixellayercopy(this: Ich4_p02_hh_ch4_p0204psdAssetchp4_p02_wcframePixellayercopy) {
	if (this.setLayoutTexture) this.setLayoutTexture("Pixellayercopy", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch4_p02_hh_ch4_p0204psdAssetchp4_p02_wcframePixellayercopy2(this: Ich4_p02_hh_ch4_p0204psdAssetchp4_p02_wcframePixellayercopy2) {
	if (this.setLayoutTexture) this.setLayoutTexture("Pixellayercopy2", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch4_p02_hh_ch4_p0204psdAssetchp4_p02_wcframeRlineart(this: Ich4_p02_hh_ch4_p0204psdAssetchp4_p02_wcframeRlineart) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rlineart", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p02_hh_ch4_p0204psdAssetchp4_p02_wcframeLlineart(this: Ich4_p02_hh_ch4_p0204psdAssetchp4_p02_wcframeLlineart) {
	if (this.setLayoutTexture) this.setLayoutTexture("Llineart", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich4_p02Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich4_p02Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich4_p02Sprite extends Ich4_p02Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich4_p02Text extends Ich4_p02Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich4_p02Polygon extends Array<number> {
}
interface Ich4_p02 {
	readonly holly: Ich4_p02Array<Ich4_p02_hh_ch4_p0204psdAssetchp4_p02_hollyp2|Ich4_p02_hh_ch4_p0204psdAssetchp4_p02_hollyp3|Ich4_p02_hh_ch4_p0204psdAssetchp4_p02_hollyp4>;
	readonly bg: Ich4_p02_hh_ch4_p0204psdAssetchp4_p02_bg;
	readonly guitarStand: Ich4_p02_hh_ch4_p0204psdAssetchp4_p02_guitarstand;
	readonly basket: Ich4_p02_hh_ch4_p0204psdAssetchp4_p02_basket;
	readonly frameRight: Ich4_p02_hh_ch4_p0204psdAssetchp4_p02_wcframePixellayercopy;
	readonly frameLeft: Ich4_p02_hh_ch4_p0204psdAssetchp4_p02_wcframePixellayercopy2;
	readonly linesLeft: Ich4_p02_hh_ch4_p0204psdAssetchp4_p02_wcframeRlineart;
	readonly linesRight: Ich4_p02_hh_ch4_p0204psdAssetchp4_p02_wcframeLlineart;
}
interface Ich4_p02_hh_ch4_p0204psdAssetchp4_p02_bg extends Ich4_p02Sprite {
}
interface Ich4_p02_hh_ch4_p0204psdAssetchp4_p02_guitarstand extends Ich4_p02Sprite {
}
interface Ich4_p02_hh_ch4_p0204psdAssetchp4_p02_basket extends Ich4_p02Sprite {
}
interface Ich4_p02_hh_ch4_p0204psdAssetchp4_p02_hollyp2 extends Ich4_p02Sprite {
}
interface Ich4_p02_hh_ch4_p0204psdAssetchp4_p02_hollyp3 extends Ich4_p02Sprite {
}
interface Ich4_p02_hh_ch4_p0204psdAssetchp4_p02_hollyp4 extends Ich4_p02Sprite {
}
interface Ich4_p02_hh_ch4_p0204psdAssetchp4_p02_wcframePixellayercopy extends Ich4_p02Sprite {
}
interface Ich4_p02_hh_ch4_p0204psdAssetchp4_p02_wcframePixellayercopy2 extends Ich4_p02Sprite {
}
interface Ich4_p02_hh_ch4_p0204psdAssetchp4_p02_wcframeRlineart extends Ich4_p02Sprite {
}
interface Ich4_p02_hh_ch4_p0204psdAssetchp4_p02_wcframeLlineart extends Ich4_p02Sprite {
}
